import React, { useMemo } from "react";
import { Select } from "antd";
import { KeyboardArrowDown } from "@mui/icons-material";
import Flag from "react-world-flags";
import { useCountry } from "../context/CountryContext";

const NavbarCountrySelector = () => {
  const { selectedCountry, setSelectedCountry, teleCode } = useCountry();

  const selectedCountryData = useMemo(() => {
    if (!selectedCountry || !teleCode?.length) return null;
    return teleCode.find(
      (item) => item.name.toLowerCase() === selectedCountry.toLowerCase(),
    );
  }, [selectedCountry, teleCode]);

  return (
    <li className="navbar-country-selector">
      <div className="navbar-country-control">
        <div className="navbar-country-value">
          {selectedCountryData ? (
            <>
              <Flag
                code={selectedCountryData.iso2}
                className="navbar-country-flag"
              />
              <span className="navbar-country-name">
                {selectedCountryData.name}
              </span>
            </>
          ) : (
            <span className="navbar-country-name navbar-country-placeholder">
              Country
            </span>
          )}
          <KeyboardArrowDown className="navbar-country-chevron" />
        </div>

        <Select
          className="navbar-country-select"
          placeholder="Country"
          value={selectedCountry || undefined}
          showSearch
          variant="borderless"
          popupMatchSelectWidth={false}
          onChange={(val) => setSelectedCountry(val)}
          optionFilterProp="label"
          suffixIcon={null}
          disabled={!teleCode?.length}
        >
          {teleCode.map((item) => (
            <Select.Option key={item.iso2} value={item.name} label={item.name}>
              <div className="country-option navbar-country-dropdown-option">
                <Flag
                  code={item.iso2}
                  style={{ height: "16px", width: "16px" }}
                />
                <span>{item.name}</span>
              </div>
            </Select.Option>
          ))}
        </Select>
      </div>
    </li>
  );
};

export default NavbarCountrySelector;
